import { useQuery } from "@apollo/client";
import { GET_ALL_DEVICES_V2 } from "src/modules/graphql/queries";
import { GET_DEVICES } from "./MapOverviewTrafficLite.queries";

/**
 * Hook pour recuperer la liste des vehicules/devices depuis l'API
 * @returns {Object} { devices, loading, error, refetch }
 */
export const useDevices = (options = {}) => {
  const { useV2 = false, filters = {} } = options;
  const queryDocument = useV2 ? GET_ALL_DEVICES_V2 : GET_DEVICES;

  const { data, loading, error, refetch } = useQuery(queryDocument, {
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-and-network",
    pollInterval: 30000,
    ...(useV2 ? { variables: { filters } } : {}),
  });

  const devices = useV2
    ? (data?.getAllDeviceLocationsGroupV2 || []).flatMap((clientGroup) =>
        (clientGroup?.devices || []).map((device) => ({
          ...device,
          clientName: clientGroup?.clientName,
          clientKey: clientGroup?.clientKey,
          clientLoginId: clientGroup?.clientLoginId,
        }))
      )
    : data?.devices || [];

  return {
    devices,
    loading,
    error,
    refetch,
  };
};
